import styled from 'styled-components';

import { Typography } from '../typography';
import { NavLink } from "react-router-dom";
import colors from "../../assets/colors";

const StyledNavLink = styled(NavLink)<{match: {} | null, img: string}>`
	display: flex;
	align-items: center;
	padding: 10px;
	margin-bottom: 10px;
	
	&:hover {
		background-color: #F7F7F9;
		border-radius: ${(p) => p.match ? '0' : '10px'};
	}
	
	&.active {
		border-left: ${(p) => p.img !== 'settings' ? `1px solid ${colors.sapphirine}` : 'none'};
	}
`;

const Title = styled(Typography)`
	@media (max-width: 1024px) {
		display: none;
	}
`;

const Img = styled.img`
	height: 24px;
	width: 24px;
	margin-right: 14px;

	@media (max-width: 1024px) {
		height: 19px;
		width: 19px;
	}
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	StyledNavLink,
	Title,
	Img,
};
